<p [ngSwitch]="schedule.frequency" class="info-banner" data-test="banner-text">
  <mode-delivery-info
    [entity]="entity"
    [schedule]="schedule"
    [slackChannel]="slackChannel"
    [notifyType]="notifyType"
    [numberOfSubscribers]="numberOfSubscribers"
  >
  </mode-delivery-info>

  <ng-container *ngSwitchCase="'every_15_minutes'">
    <span class="frequency">every 15 minutes</span>
    starting at
    <span class="time">{{ minuteDescription }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'every_30_minutes'">
    <span class="frequency">every 30 minutes</span>
    starting at
    <span class="time">{{ minuteDescription }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'hourly'">
    <span class="frequency">every hour</span>
    at
    <span class="time">{{ minuteDescription }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'daily'">
    <span class="frequency">every day</span>
    at
    <span class="time">{{ schedule | timeWithTimeZone }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'weekday'">
    <span class="frequency">every weekday</span>
    at
    <span class="time">{{ schedule | timeWithTimeZone }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'weekly'">
    <span class="frequency">every {{ schedule.dayOfTheWeek }}</span>
    at
    <span class="time">{{ schedule | timeWithTimeZone }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'monthly'">
    <span class="frequency">every {{ schedule.dayOfMonth }} of the month</span>
    at
    <span class="time">{{ schedule | timeWithTimeZone }}</span>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <span class="frequency">{{ schedule.frequency }}</span>
    at
    <span class="time">{{ schedule | timeWithTimeZone }}</span>
  </ng-container>
  <ng-container *ngIf="entity === 'sqlDataset'"
    >. Reports using this Dataset can load in the updated results as soon as the schedule completes.</ng-container
  >
  <ng-container *ngIf="entity === 'gsheetDataset'"
    >, so long as the Dataset creator is logged into their Google account. Reports using this Dataset can load in the updated results as soon as the schedule completes.</ng-container
  >
</p>
